import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=d9b01520&scoped=true&"
import script from "./customList.vue?vue&type=script&lang=js&"
export * from "./customList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b01520",
  null
  
)

export default component.exports